import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Popup from 'reactjs-popup';
import {fetchMyTournamentPrintKitRequest} from '../../../actions/tournamentPrintKitRequest.actions';
import {Button, ButtonGroup, PageContainer, PageTitle, PcBangPopup, Table} from '../../Common/PageComponents';
import './tournamentKit.scss';

const stateToProps = state => {
  return {
    tournamentPrintKitRequest: state.tournamentPrintKitRequest,
  };
};

class TournamentKit extends Component {
  componentDidMount() {
    this.props.dispatch(fetchMyTournamentPrintKitRequest());
  }

  _renderTournamentGuidePopup(close) {
    return (
      <div>
        <div className="guide" id="printArea">
          <strong>리그 오브 레전드 PC방 자체 토너먼트 진행 가이드</strong>
          <br />
          <br />
          <dl>
            <dt>■</dt>{' '}
            <dd>
              <b>대회 홍보</b>
              <br />
            </dd>
            <dt>1.</dt>
            <dd>POP부착 : 가로포스터, 세로포스터, 대진표를 매장구조에 맞게 잘 보이는 곳에 부착합니다.</dd>
            <dt>2.</dt>{' '}
            <dd>
              매장 내 홍보
              <span className="indent_l"></span>
            </dd>
            <dt>ㄱ.</dt>
            <dd>간단한 대회 안내지를 작성하여 매장에 부착합니다.(내부, 외부)</dd>
            <dt>ㄴ.</dt>
            <dd>단골손님 등 매장 내 손님들에게 구두로 대회가 있음을 알립니다.</dd>
            <dt>3.</dt>
            <dd>매장 내 홍보 기간 : 대회일자에 맞추어 탄력적으로 결정합니다.</dd>
            <dt>4.</dt>{' '}
            <dd>
              매장 카운터에 이름, 연락처, 팀명, 소환사명 등이 포함된 대회참여 신청양식을 비치합니다.
              <br />
              <br />
            </dd>
            <dt>■</dt>{' '}
            <dd>
              <b>참가자접수</b>
              <br />
            </dd>
            <dt>1.</dt>{' '}
            <dd>
              참가자 자격 조건은 업주님이 정하면 되나, 만 14세 미만의 유저가 대회에 참여할 경우에는 별도로 법정대리인
              동의서를 받으셔야 합니다. (리그 오브 레전드는 12세 이용가 입니다.)
            </dd>
            <dt>2.</dt>{' '}
            <dd>
              신청양식을 통하여 대회 참가접수를 받으며, 대회설명(상품, 대회 당일 PC방 이용료 등)을 합니다.
              <br />
              <br />
            </dd>
            <dt>■</dt>{' '}
            <dd>
              <b>대회진행</b>
              <br />
            </dd>
            <dt>1.</dt>
            <dd>좌석 점검</dd>
            <span className="indent_l">
              <dt>ㄱ.</dt>{' '}
              <dd>
                클라이언트가 정상적으로 설치되어 게임이 원활하게 플레이 되는지 마우스 및 헤드셋이 정상적으로 작동하는지
                확인합니다.
              </dd>
              <dt>ㄴ.</dt>{' '}
              <dd>
                리그 오브 레전드 대회는 주로 5대5 경기로 이루어지므로 좌석배치는 5명이 나란히 앉을 수 있도록 합니다.
                <br />
                <br />
              </dd>
            </span>
            <dt>2.</dt>
            <dd>참가자확인</dd>
            <span className="indent_l">
              <dt>ㄱ.</dt> <dd>대회시작 약 40분 전부터 참가자를 확인합니다.</dd>
              <dt>ㄴ.</dt> <dd>참가자가 확인되면 팀 좌석을 안내하여 개인 PC세팅을 시작합니다.</dd>
              <dt>ㄷ.</dt> <dd>대회시작 20분 전에 각 팀 팀장을 불러 대진표 추첨을 진행하고, 대진표를 작성합니다.</dd>
              <dt>ㄹ.</dt>{' '}
              <dd>
                대진표 작성이 완료되면 전체 대회규정을 안내합니다.
                <br />
                <br />
              </dd>
            </span>
            <dt>3.</dt>
            <dd>경기시작</dd>
            <span className="indent_l">
              <dt>ㄱ.</dt>{' '}
              <dd>
                서로 대전을 시작할 팀의 팀장을 불러 2개팀 중 1팀이 방을 생성하게 합니다.(진영선택: 방을 생성한 팀이
                밑에서 위로 경기진행)
              </dd>
              <dt>ㄴ.</dt> <dd>진영선택은 대전 팀장들이 가위바위보로 정하는 것이 좋습니다.</dd>
              <dt>ㄷ.</dt>{' '}
              <dd>
                방생성은 ‘게임 시작 → 사용자 설정 → 게임 생성 → 소환사의 협곡 → 팀 인원 수 5명 → 게임종류 선택 → 방 이름
                생성 → 비밀번호 설정 → 게임 생성’ 과정으로 진행합니다.
              </dd>
              <dt>ㄹ.</dt>{' '}
              <dd>
                방이 생성되면 방을 생성한 팀의 팀장은 팀원을 방으로 초대하고 상대팀은 방을 찾아 비밀번호를 입력하여 해당
                방에 입장합니다.
              </dd>
              <dt>ㅁ.</dt> <dd>생성된 방에 전체 인원의 입장이 확인될 경우 소환사를 선택하고 준비를 완료합니다.</dd>
              <dt>ㅂ.</dt> <dd>모든 준비가 완료되면, 10초 후 경기가 시작됩니다.</dd>
              <dt>ㅅ.</dt>{' '}
              <dd>
                경기 중 게임에 문제가 발생할 경우 해당 팀의 팀장이 대회 운영자에게 알릴 수 있도록 합니다.
                <br />
                <br />
              </dd>
            </span>
            <dt>4.</dt>
            <dd>경기종료</dd>
            <span className="indent_l">
              <dt>ㄱ.</dt> <dd>경기가 종료되면 승리 팀의 팀장이 승패 여부를 대회 운영자에게 알려주도록 합니다.</dd>
              <dt>ㄴ.</dt>{' '}
              <dd>
                대회 운영자는 대진표를 작성하고, 승리 팀 팀장에게 다음 경기를 준비할 수 있도록 합니다.
                <br />
                <br />
              </dd>
            </span>
            <dt>■</dt>{' '}
            <dd>
              <b>시상</b>
              <br />
            </dd>
            <dt>1.</dt>{' '}
            <dd>
              모든 경기가 종료되면 정해진 시상 순위대로 시상식을 진행합니다.
              <br />
              <br />
            </dd>
            <dt>■</dt>{' '}
            <dd>
              <b>참고사항</b>
              <br />
            </dd>
            <dt>1.</dt>{' '}
            <dd>
              대회규정은 리그 오브 레전드 PC방 토너먼트 페이지 내 ‘주의사항 전체보기’를 참조하시어, 대회 성격 및 매장
              환경에 맞게 적용하시면 됩니다. <br />
              <a
                className="dos-and-donts-link"
                href="http://www.leagueoflegends.co.kr/e-sports/pcroom/pop_pcleague.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                &lt;[주의사항 전체보기] 바로가기&gt;
              </a>
            </dd>
            <dt>2.</dt>{' '}
            <dd>
              대회를 하루에 진행하는 경우, 최소 8강/최대 16강 토너먼트로 진행하는 것이 적합합니다. <br />
              (프린트 키트 대진표의 경우에도 8강, 16강 토너먼트 대진표가 준비되어 있습니다.)
            </dd>
            <dt>3.</dt>{' '}
            <dd>
              8강전까지는 단판으로, 4강(준결승) 및 결승의 경우 3판 2선승제로 진행하는 것이 일반적입니다. 다만 해당
              내용은 대회 진행 시간에 맞춰 조정하시면 됩니다. <br />
              (일반적으로 한 경기의 준비에서 종료까지 소요되는 시간은 45분~1 시간 입니다.)
            </dd>
            <dt>4.</dt>{' '}
            <dd>
              팀장을 제외한 인원은 되도록 이동을 자제하게 하고, 반드시 욕설 및 고성에 대해서 경기 전 미리 주의를 주셔야
              합니다.
            </dd>
            <dt>5.</dt>{' '}
            <dd>
              게임종류 선택은 주로 비공개선택(블라인드픽), 교차선택(밴픽) 2가지로 진행되며, 반드시 대회 규정에
              포함시켜야 합니다. 만약 대회 게임종류 변경이 필요할 경우에는 대회 당일 모든 대회참가자의 동의 하에
              변경하시면 됩니다.
            </dd>
            <dt>6.</dt>{' '}
            <dd>
              참가 확정 팀 중 대회시간에 게임시간선택제가 적용된 팀원이 있을 경우 대회에 참가할 수 없게 되오니, 해당
              팀원은 다른 팀원으로 교체해 주시기 바랍니다.{' '}
            </dd>
            <dt>7.</dt>{' '}
            <dd>
              자체 대회 상품은 별도로 지원하지 않으며, PC방 자체 대회 진행과 관련된 모든 내용은 라이엇 게임즈 코리아와는
              관련이 없습니다.
            </dd>
          </dl>
        </div>
        <ButtonGroup>
          <Button
            onClick={e => {
              e.preventDefault();
              window.open('/html/tournament_guide_for_print.html');
            }}
          >
            인쇄
          </Button>
          <Button
            theme={'gray'}
            onClick={e => {
              e.preventDefault();
              close();
            }}
          >
            확인
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  _renderExistingRequestPopup(close) {
    let request = this.props.tournamentPrintKitRequest;

    return (
      <div>
        <div className="payment-result-title">신청완료</div>
        <Table>
          <colgroup>
            <col width="120" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th>PC방명</th>
              <td>{request.pcBangName}</td>
            </tr>
            <tr>
              <th>주소</th>
              <td>{request.address}</td>
            </tr>
            <tr>
              <th>연락처</th>
              <td>{request.phone}</td>
            </tr>
            <tr>
              <th>대회규모</th>
              <td>
                <b>{request.tournamentRound}</b>
              </td>
            </tr>
            <tr>
              <th>대회일시</th>
              <td>{request.tournamentDate}</td>
            </tr>
            <tr>
              <th>대회소개</th>
              <td>{request.description}</td>
            </tr>
            <tr>
              <th>
                포스터 <br />
                이미지 선택
              </th>
              <td>
                <div className="box">
                  <ul style={{display: 'flex'}}>
                    <li>
                      <dl>
                        <dt>
                          <img src="/image/customer/kit/poster1_s_2019.jpg" alt="POSTER 1" />
                        </dt>
                        <dd>
                          POSTER 1<br />({request.posterRequestCounts.poster1}개)
                        </dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt>
                          <img src="/image/customer/kit/poster2_s_2019.jpg" alt="POSTER 2" />
                        </dt>
                        <dd>
                          POSTER 2<br />({request.posterRequestCounts.poster2}개)
                        </dd>
                      </dl>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
        <ButtonGroup>
          <Button theme={'gray'} onClick={() => close()}>
            확인
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="토너먼트 키트" />
        <div className="kit1">
          <PcBangPopup
            closeOnDocumentClick
            contentStyle={{padding: 0, width: '498px'}}
            trigger={
              <a href="#">
                <img src="/image/customer/kit/btn_kit_1.gif" alt="대회 규정 및 진행 방법 안내" />
              </a>
            }
            render={close => this._renderTournamentGuidePopup(close)}
            title={'대회 규정 및 진행 방법 안내'}
          />
        </div>
        <div className="kit2">
          <Popup
            modal
            closeOnDocumentClick
            contentStyle={{padding: 0, width: '716px', height: '696px'}}
            trigger={
              <a href="#">
                <img src="/image/customer/kit/btn_kit_2.gif" alt="토너먼트 키트 미리보기" />
              </a>
            }
          >
            <img src="/image/customer/kit/tou_kit_pop1_2019.jpg" />
          </Popup>
        </div>
        <div className="kit3">
          <ul>
            <li>
              <Link to="/news/tournament-kit/digital-kit-download/agreement">
                <img src="/image/customer/kit/btn_kit_3.gif" alt="디지털 키트 다운로드" />
              </Link>
            </li>
            <li>
              {this.props.tournamentPrintKitRequest ? (
                <PcBangPopup
                  closeOnDocumentClick
                  contentStyle={{padding: 0, width: '650px', height: '570px'}}
                  trigger={
                    <a href="#">
                      <img src="/image/customer/kit/btn_kit_5.gif" alt="프린트 키트 신청 내역 확인" />
                    </a>
                  }
                  render={close => this._renderExistingRequestPopup(close)}
                  title={'프린트 키트 신청 내역 확인'}
                />
              ) : (
                <Link to="/news/tournament-kit/print-kit-request/agreement">
                  <img src="/image/customer/kit/btn_kit_4.gif" alt="프린트 키트 신청하기" />
                </Link>
              )}
            </li>
          </ul>
        </div>
        <div>
          <img src="/image/customer/kit/tou_kit_04.jpg" alt="유의사항" />
        </div>
      </PageContainer>
    );
  }
}

export default connect(stateToProps)(TournamentKit);
